import {ProductBrandModel} from "./products.model";
import AppStore from "../../app.store";
import axios, { GenericAbortSignal } from "axios";
import {api} from "../../api/endpoints";
import { makeAutoObservable } from "mobx";
import {SELECT_PAGE_LIMIT} from "../../utils/pagination";

class ProductBrandStore {
    public productBrands ?: ProductBrandModel[];

    public productBrandsInit = (signal: GenericAbortSignal, pageLimit = SELECT_PAGE_LIMIT) => {
        void this.productBrandReq(signal, pageLimit);
    }

    constructor() {
        makeAutoObservable(this);
    }

    setProductBrands(data: any) {
        const {brands} = data;
        this.productBrands = brands;
    }

    public productBrandReq = async (signal?: GenericAbortSignal, pageLimit = SELECT_PAGE_LIMIT) => {

        try {
            const {getHeaders} = AppStore

            const headers = getHeaders()

            let response:any = await axios.get(api.product_brands + `?page=1&page_limit=${pageLimit}`, {headers, signal});

            this.setProductBrands(response.data)
        } catch (err) {
        }
    }
}

export default new ProductBrandStore();